import {Component, ElementRef, HostBinding, Input, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-side-color-card',
  templateUrl: './side-color-card.component.html',
  styleUrls: ['./side-color-card.component.scss']
})
export class SideColorCardComponent implements OnInit {

  @Input() color;

  constructor() { }

  ngOnInit(): void {
  }
}
